export function setApplicationData(data) {
    return {
        type: "SET_APPLICATION_DATA",
        payload: data
    }
}
